export const TEST_ID = 'toggleFlightPathsButton';
